import { render, staticRenderFns } from "./TaxesTable.vue?vue&type=template&id=c775e3e4&"
import script from "./TaxesTable.vue?vue&type=script&lang=js&"
export * from "./TaxesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports